import React, { Fragment } from 'react';
import {
    EuiFormRow,
} from '@elastic/eui';
import { useIntl, FormattedMessage } from 'react-intl';

import EuiLinkButton from '../../components/EuiLinkButton'

const DeleteAccount = () => {
    const intl = useIntl()

    return (
        <Fragment>
            <EuiFormRow fullWidth helpText={intl.formatMessage({ id: "Dashboard.DeleteAccount.helpText" })} >
                <span></span>
            </EuiFormRow>
            <EuiLinkButton fill to="/deleteAccount" >
                <FormattedMessage id="Dashboard.DeleteAccount.buttonText" />
            </EuiLinkButton>
        </Fragment>
    );
}

export default DeleteAccount;
